module.exports = __webpack_public_path__ + "static/media/cert.acf82700.jpg";